
import { Component, Vue } from 'vue-property-decorator';
import { namespace } from "vuex-class";

import "@/store/modules/forms/form2";
const form2State = namespace("Form2");

import "@/store/modules/forms/form3";
const form3State = namespace("Form3");

import "@/store/modules/forms/form4";
const form4State = namespace("Form4");

import StepNumber from "@/components/utils/StepNumber.vue";
import { form3DataInfoType, form3QualificationInfoType } from '@/types/Information/Form3';

@Component({
    components:{
        StepNumber
    }
})
export default class Form1QualifyQuestions extends Vue {

    @form2State.Action
    public UpdateCurrentCaseId!: (newCurrentCaseId: string) => void        
        
    @form3State.State
    public currentNoticeOfCrossAppealId: string;

    @form3State.State
    public form3Info: form3DataInfoType;

    @form4State.Action
    public UpdateCurrentNoticeOfApplicationId!: (newCurrentNoticeOfApplicationId: string) => void


    dataReady = false;
    stepStyle = "font-size: 2rem;";
    qualificationInfo = {} as form3QualificationInfoType;
    update = 0;

    state = {
        selfRepresenting: null,  
        filedNoA: null,
        vary: null,        
        insideTimeLimit: null,         
        appealingFeesWaived: null,        
        appealingSupremeCourtOrder:null,
        appealingScFlaDivorce:null        
    }   

    responseOptions = [
        {text: 'Yes', value: true},
        {text: 'No', value: false}
    ];

    mounted(){
        this.dataReady = false;
        this.qualificationInfo = {} as form3QualificationInfoType;
        if (this.currentNoticeOfCrossAppealId && this.form3Info){         
            this.extractData();            
        } else {            
            this.qualificationInfo.selfRepresenting = this.$store.state.Common.userSelfRepresented;
            this.clearStates();
            this.qualificationResponse();
            Vue.nextTick(()=> {
                this.dataReady = true;
            });
        }
    }
    
    public extractData(){
        this.qualificationInfo.selfRepresenting = this.form3Info.selfRepresenting;
        this.qualificationInfo.filedNoA = this.form3Info.filedNoA;
        this.qualificationInfo.vary = this.form3Info.vary;
        this.qualificationInfo.appealingScFlaDivorce = this.form3Info.appealingScFlaDivorce;
        this.qualificationInfo.insideTimeLimit = this.form3Info.insideTimeLimit;
        this.qualificationInfo.appealingSupremeCourtOrder = this.form3Info.appealingSupremeCourtOrder;
        this.qualificationInfo.appealingFeesWaived = this.form3Info.appealingFeesWaived;        

        this.qualificationResponse();
            
        Vue.nextTick(()=> {
            this.dataReady = true;
        });
    }


    public qualificationResponse(){ 
        const qualified = this.checkStates() && this.qualificationInfo.filedNoA;
        this.$emit('disableContinue', !qualified, this.qualificationInfo);          
        this.update++;            
    }
 

    public clearStates(){       
        this.state = {
            selfRepresenting: null,  
            filedNoA: null,
            vary: null,        
            insideTimeLimit: null,         
            appealingFeesWaived: null,        
            appealingSupremeCourtOrder:null,
            appealingScFlaDivorce:null    
        }         
    }
    
    public checkStates(){       
        this.state.selfRepresenting = (this.qualificationInfo.selfRepresenting == null)? false : null;
        this.state.filedNoA = (this.qualificationInfo.filedNoA == null)? false : null;
        this.state.insideTimeLimit = (this.qualificationInfo.insideTimeLimit == null)? false : null; 
        this.state.vary = (this.qualificationInfo.vary == null)? false : null; 
        this.state.appealingFeesWaived = (this.qualificationInfo.appealingFeesWaived == null)? false : null; 
        this.state.appealingSupremeCourtOrder = (this.qualificationInfo.appealingSupremeCourtOrder == null)? false : null; 
        this.state.appealingScFlaDivorce = (this.qualificationInfo.appealingScFlaDivorce == null)? false : null;            
        
        for(const field of Object.keys(this.state)){
            if(this.state[field]==false)
                return false
        }
        return true            
    }  
    
    public startNewForm4Document(){
        this.UpdateCurrentNoticeOfApplicationId(null);
        this.$router.push({name: "start-form4" });
    }

    public startNewForm22Document(){
        this.UpdateCurrentNoticeOfApplicationId(null);
        this.$router.push({name: "start-form22" });
    }

    public startNewForm2Document(){
        this.UpdateCurrentCaseId(null);
        this.$router.push({name: "start-form2" });
    }

}
